import Vue from 'vue';

function asStatus(el, binding) {
  // el.className = '';
  el.classList.add('badge');

  const statusToColorMap = {
    draft: ['border'],
    active: ['bg-success', 'text-white'],
    finished: ['bg-success', 'text-white'],
    paid: ['bg-success', 'text-white'],
    pending: ['bg-warning', 'text-white'],
    condition_request_pending: ['bg-warning', 'text-white'],
    blocked: ['bg-danger', 'text-white'],
    unsold: ['bg-danger', 'text-white'],
    unpaid: ['bg-warning', 'text-white'],
    cancelled: ['bg-danger', 'text-white'],
    lotted: ['bg-primary', 'text-white'],
    reserved: ['bg-primary', 'text-white'],
    sold: ['bg-success', 'text-white'],
    withdrawn: ['bg-warning', 'text-white'],
    rejected: ['bg-danger', 'text-white'],
    condition_request_rejected: ['bg-danger', 'text-white'],
    awaiting_deposit: ['bg-warning', 'text-white'],
    confirmed: ['bg-success', 'text-white'],
    settled: ['bg-warning', 'text-white'],
    checked: ['bg-success', 'text-white'],
    unchecked: ['bg-danger', 'text-white'],
    dispatched: ['bg-primary', 'text-white'],
    published: ['bg-primary', 'text-white'],
    released: ['bg-primary', 'text-white'],
    completed: ['bg-success', 'text-white'],
    approved: ['bg-success', 'text-white'],
    resolved: ['bg-success', 'text-white'],
    sent: ['bg-warning', 'text-white'],
    condition_request_sent: ['bg-success', 'text-white'],
    signed: ['bg-success', 'text-white'],
    reserve_met: ['bg-success', 'text-white'],
    reserve_not_met: ['bg-danger', 'text-white'],
    negotiation_started: ['bg-warning', 'text-white'],
    negotiation_completed: ['bg-success', 'text-white'],
    // Bid types
    negotiation_bid: ['bg-warning', 'text-white'],
    standard: ['bg-success', 'text-white'],
    auto: ['bg-primary', 'text-white'],
    credited: ['bg-secondary'],
    collected: ['bg-success', 'text-white'],
    returned: ['bg-warning', 'text-white'],
    sent_for_signature: ['bg-warning', 'text-white'],
    being_processed: ['bg-primary', 'text-white'],
    processed: ['bg-success', 'text-white'],
    invoice_paid: ['bg-success', 'text-white'],
    invoice_issued: ['bg-warning', 'text-white'],
    debited: ['bg-secondary'],
    suggestion_not_sent: ['bg-warning', 'text-white'],
    waiting: ['bg-primary', 'text-white'],
    // Proposal status
    proposal_seller_confirmed: ['bg-success', 'text-white'],
    proposal_draft: ['border'],
    proposal_suggestion_not_sent: ['bg-warning', 'text-white'],
    proposal_waiting: ['bg-primary', 'text-white'],
    // Auto-payment statuses
    grace_period: ['bg-secondary'],
    awaiting_approval: ['bg-warning', 'text-white'],
    n_a: ['bg-secondary'],
    charge_attempted: ['bg-primary', 'text-white'],
  };

  if (statusToColorMap[binding.value]) {
    let statuses = Object.keys(statusToColorMap)
    statuses.splice(statuses.indexOf(binding.value), 1)

    statuses.map(status => el.classList.remove(...statusToColorMap[status]))
    el.classList.add(...statusToColorMap[binding.value]);
  } else {
    el.classList.add('border');
  }
}

Vue.directive('as-status', {
  inserted: asStatus,
  update: asStatus,
  componentUpdated: asStatus,
});

export {
  asStatus
}
